import { render, staticRenderFns } from "./ASINsDetailed.vue?vue&type=template&id=01302d28&scoped=true"
import script from "./ASINsDetailed.vue?vue&type=script&lang=js"
export * from "./ASINsDetailed.vue?vue&type=script&lang=js"
import style0 from "./ASINsDetailed.vue?vue&type=style&index=0&id=01302d28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01302d28",
  null
  
)

export default component.exports